import StarRow from '@/components/ui/StarRow';
import { COPY } from '@/lib/copy';
import type { CmsReview } from '@/lib/contentful/types';

export function FeaturedReview({ review }: { review: CmsReview }) {
  return (
    <figure className="bg-bg-highlight border-l-[3px] border-primary p-9 flex flex-col justify-between m-0 min-h-[220px]">
      <blockquote className="font-serif text-[1.1rem] text-text leading-[1.8] flex-1 mb-6 m-0 p-0 border-none">
        &ldquo;{review.text}&rdquo;
      </blockquote>
      <figcaption>
        <div className="flex items-center gap-3">
          <div
            className="w-[38px] h-[38px] rounded-full bg-primary flex items-center justify-center font-sans text-[0.8rem] font-bold text-white shrink-0"
            aria-hidden="true"
          >
            {review.authorName.charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="font-sans text-[0.82rem] font-bold text-text leading-snug">
              {review.authorName}
            </p>
            <div className="flex items-center gap-1 mt-[0.15rem]">
              <StarRow count={review.rating} size={11} />
              <span className="sr-only">
                {COPY.reviews.starsLabel(review.rating)}
              </span>
            </div>
          </div>
        </div>
      </figcaption>
    </figure>
  );
}

export function SmallReview({ review }: { review: CmsReview }) {
  return (
    <figure className="bg-white border-l-[3px] border-primary px-6 py-5 flex-1 flex flex-col justify-between m-0 transition-[border-color] duration-200 hover:border-color-primary-dark">
      <blockquote className="font-sans text-[0.88rem] font-light text-color-text-mid leading-[1.75] mb-3 flex-1 m-0 p-0 border-none">
        &ldquo;{review.text}&rdquo;
      </blockquote>
      <figcaption className="flex items-center justify-between gap-2">
        <span className="font-sans text-[0.72rem] font-bold text-text">
          {review.authorName}
        </span>
        <span className="flex items-center gap-1">
          <StarRow count={review.rating} size={11} />
          <span className="sr-only">{review.rating} estrelas</span>
        </span>
      </figcaption>
    </figure>
  );
}
